import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=277a31a6"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=277a31a6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\oywen\\niehao\\qft\\20260317\\vue-admin-template-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277a31a6')) {
      api.createRecord('277a31a6', component.options)
    } else {
      api.reload('277a31a6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=277a31a6", function () {
      api.rerender('277a31a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribute/distributeList/detail.vue"
export default component.exports